import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import ConditionModal from "@/Modals/WebDataManagement/MasterData/Conditions/Modal";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import { columns } from "./Columns";
import { conditionsMasterDataApi } from "@/apis/apis";

export default function ProductSizesPage() {
  return (
    <MasterDataBaseTable
      label="Condition"
      apiURL={conditionsMasterDataApi}
      columns={columns()}
      ModalComponent={ConditionModal}
      importData={BASE_IMPORT_DATA.CONDITIONS}
      enableStatus={false}
      enableSortData={true}
    />
  );
}
